import { render, staticRenderFns } from "./MaterialPurchaseModal.vue?vue&type=template&id=1d3d6c39&"
import script from "./MaterialPurchaseModal.vue?vue&type=script&lang=js&"
export * from "./MaterialPurchaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports